import Vue from 'vue'
import App from './App.vue'
import router from './router.js'

new Vue({
  router, 
  render: h => h(App)
}).$mount('#app')
Vue.config.productionTip = false
